import { RxStompConfig } from '@stomp/rx-stomp';
import { environment } from '../environments/environment';

export const myRxStompConfig: RxStompConfig = {
  // Which server?
  brokerURL: environment.stompWebsocketUrl,

  // Headers (typical keys: login, passcode, host)
  connectHeaders: {
    host: environment.stompWebsocketHost,
    login: environment.stompWebsocketUsername,
    passcode: environment.stompWebsocketPassword,
  },

  // Heartbeats (ms). Set 0 to disable.
  heartbeatIncoming: 0,
  heartbeatOutgoing: 20000,

  // Reconnect delay (ms). Set 0 to disable.
  reconnectDelay: 1000,

  // Console diagnostics (avoid in production)
  //debug: (msg: string): void => {
  // console.log(new Date(), msg);
  //},
};